// extracted by extract-css-chunks-webpack-plugin
module.exports = {"employeeGridDesktop":"_1zaP2n","card":"_1DilNn"};